import { render } from "./DomainManagement.vue?vue&type=template&id=1c18fcb2"
import script from "./DomainManagement.vue?vue&type=script&lang=js"
export * from "./DomainManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__